import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { of, Observable, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const areaCache = {};

@Injectable({
  providedIn: 'root'
})
export class PropertyPostsService {

  private strUserID: string = '1';
  private ComServiceSecureData: any;

  constructor(private _http: HttpClient) {
    this.ComServiceSecureData = localStorage.getItem('security-token') == null ? '' : JSON.parse(localStorage.getItem('security-token'));
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllStatesList(): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/masters/getstatelist/', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllStatesListByCountry(strID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/masters/getallstatelList?LookupID=' + strID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllDistrictListByState(strID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/masters/getalldistricslist?LookupID=' + strID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllCitiesByDistrict(strID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/masters/getallcitieslist?LookupID=' + strID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllAreasByCity(strID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/masters/getallareaslist?LookupID=' + strID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL DISTRICTS LIST BY STATE ID
  GetAllDistrictsList(stateID: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/masters/getdistrictlist?StateID=' + stateID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET PROPERTY TYPES
  GetAllPropertyType(): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/properties/getproperties/', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL AGENT LIST
  GetAllUnitsList(uID?: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postunit/getallpropertyunit?UnitID=' + uID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }


  //THIS IS SERVICE FOR GET ALL AGENT LIST
  GetMasterData(uID?: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postunit/getmasterdata?UnitID=' + uID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }


  //THIS IS SERVICE FOR GET PROPERTY SUB TYPES
  GetAllPropertySubType(): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/properties/getsubproperties/', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  // Modify your service method
  GetAllAreasByType(cityID: number): Observable<any> {
    const cacheKey = `areas_${cityID}`;

    if (areaCache[cacheKey]) {
      return of(areaCache[cacheKey]);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/properties/getareasbycity?DistrictId=' + cityID + '', null, httpOptions).pipe(
      tap(data => {
        areaCache[cacheKey] = data; // Store result in cache
      }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET PROPERTY SUB TYPES
  SaveUpdateUserPost(_post: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/addupdatepost/', _post, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE UPDATE POST DETAILS
  UpdatePostDetails(e: any): Observable<any> {
    return this._http.post<any>(environment.apiUrl + 'api/admin/updatepostinfo/', e).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllUserPostByID(strUserID: string, _self: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getalluserpostsbyid?UserID=' + strUserID + '&isSelf=' + _self, null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL AGENT LIST
  GetUserPostedDetails(rID?: string, pTypeID?: number, pID?: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/admin/getuserpostinfo?reqID=' + rID + '&propertyID=' + pTypeID + '&postID=' + pID
      + '', null, httpOptions).pipe(
        tap(null,
          () => {
            // An error has occurred, so increment this request's ERROR_COUNT.
          }),
        // Retry the request a configurable number of times.
        retry(2),
        catchError(this.handleError)
      );
  }


  //THIS IS SERVICE FOR GET ALL AGENT LIST
  GetUserPostDetailsByPropertyID(pID?: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/admin/getuserpostinfobypropid?propertyID=' + pID
      + '', null, httpOptions).pipe(
        tap(null,
          () => {
            // An error has occurred, so increment this request's ERROR_COUNT.
          }),
        // Retry the request a configurable number of times.
        retry(2),
        catchError(this.handleError)
      );
  }




  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAgentListUserAreas(strUserID: string, strAID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getagentspostsbyuser?UserID=' + strUserID + '&AreasID=' + strAID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetBuilderListUserAreas(strUserID: string, strAID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/builder/getbuilderpostsbyuser?UserID=' + strUserID + '&AreasID=' + strAID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetBuyUsersListsByAreas(strUserID: string, strAID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getuserslistbyagents?UserID=' + strUserID + '&AreasID=' + strAID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetPropertyCustomerList(strUserID: string, strAreas: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getpropertycustomerdetails?UserID=' + strUserID + "&areas=" + strAreas, null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  // THIS IS SERVICE FOR GET ALL STATES LIST
  GetPropertyListByFilter(strUserID: string, propertycode: string, page: number, pageSize: number, propertyType: string, reqType: string, budget: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    // Construct the request body to include propertyType, reqType, and budget
    const requestBody = {
      userId: strUserID,
      propertycode: propertycode,
      page: page,
      pageSize: pageSize,
      propertyType: propertyType,   // Add property type
      reqType: reqType,             // Add request type (Sale, Rent, etc.)
      budget: budget                // Add budget
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getpropertylistbyfilter', requestBody, httpOptions).pipe(
      tap(() => {
        // Successful request
      }, () => {
        // An error has occurred, so increment this request's ERROR_COUNT.
      }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  // THIS IS SERVICE FOR GET ALL STATES LIST
  GetPropertyListByGeneralFilter(requestBody: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getpropertylistbycombinefilter', requestBody, httpOptions).pipe(
      tap(() => {
        // Successful request
      }, () => {
        // An error has occurred, so increment this request's ERROR_COUNT.
      }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }



  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetPropertyListByAdvanceFilter(filterInfo: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getpropertylistbyadvancefilter', filterInfo, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  // Method to get top properties info with optional searchHistory
  GetTopPropertiesInfo(searchHistory?: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    const requestBody = {
      searchHistory: searchHistory || ''
    };

    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/properties/gettoppropertieslist`;
    //console.log(url);
    return this._http.post(url, requestBody, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }

  // Method to get top properties info with optional searchHistory
  GetTopAgentsInfo(searchHistory?: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/postrequest/gettopagentprofiles`;
    return this._http.post(url, null, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }



  //THIS IS SERVICE FOR GET ALL REPORT FROUD LIST
  GetAllReportFraudInfo(): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/properties/getreportfraudslist/', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL REPORT FROUD LIST
  InsertPropertyReport(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/insertpropertyreport/', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllAgentProfilePost(strUserID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getagentprofilepost?UserID=' + strUserID, null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  UserAuthencations(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/checkuserauth', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetAllBusinessCategory(): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getparentcategorylist/', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetAllBusinessSubCategory(cid: number, pid: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getbusinesscategorylist?catId=' + cid + '&parentId=' + pid + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetHomeBusinessPartnersLine(cid: number, aid: string, type: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/gethomepartnerslistbycategory?catId=' + cid + '&areasId=' + aid + '&option=' + type + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetCategoryByParent(cid: number, pid: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getbusinesscategorylist?catId=' + cid + '&parentId=' + pid + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  // Method to get top properties info with optional searchHistory
  GetTopHomePropertyInfo(type: string, page: number, pageSize: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/postrequest/gethometopproperties?pType=${type}&page=${page}&pagesize=${pageSize}`;
    return this._http.post(url, null, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }

  // Method to get top properties info with optional searchHistory
  GetPropertyInfoById(pageId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };
    var reqBody = {
      "RequestID": pageId
    }
    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/postrequest/getpropertylistbypropertyid`;
    return this._http.post(url, reqBody, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }

  // Method to get top properties info with optional searchHistory
  StoreUserSearchHistory(reqBody: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/properties/insertpropertysearch`;
    return this._http.post(url, reqBody, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET PROPERTY SUB TYPES
  GetApplyPropertyFilter(filter: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getpropertylistbycombinefilter', filter, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }


  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(error);
  }

  //THIS IS THE FUNCATION FOR CONVERT TO LOCAL(YYYY-MM-DD) DATE FORMAT BY GIVEN DATE FORMAT
  private ConvertToDate(strD: any): string {
    return new Date(new Date(strD).getFullYear(), new Date(strD).getMonth(), ((new Date(strD).getDate()) + 1)).toISOString().slice(0, 10);
  }


  GetPropertyPerformanceByRequestID(requestID: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/getpropertyperformancebyrequestid?requestID=' + requestID + '', null, httpOptions).pipe(
      tap(
        (response) => {
          // Handle successful response if needed
        },
        (error) => {
          // Handle error response if needed
        }
      ),
      retry(2), // Retry the request up to 2 times if it fails
      catchError(this.handleError) // Handle errors
    );
  }

  GetLikePropertyByRequestID(requestID: number, userId: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let data =
    {
      "RequestID": requestID,
      "UserID": userId
    }

    return this._http.post(environment.apiUrl + 'api/properties/addlike', data, httpOptions).pipe(
      tap(
        (response) => {
          // Handle successful response if needed
        },
        (error) => {
          // Handle error response if needed
        }
      ),
      retry(2), // Retry the request up to 2 times if it fails
      catchError(this.handleError) // Handle errors
    );
  }

  getHomeMapProperties(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    // Since it's a POST request with no body, you can send empty object or null
    let data = {};

    return this._http.post(environment.apiUrl + 'api/postrequest/gethomemapproperties', data, httpOptions).pipe(
      tap(
        (response) => {
          // Handle successful response if needed
        },
        (error) => {
          // Handle error response if needed
          console.error('Error loading home map properties', error);
        }
      ),
      retry(2), // Retry the request up to 2 times if it fails
      catchError(this.handleError) // Handle errors
    );
  }


  GetMySnaps(userId: string): Observable<any> {
    const url = environment.apiUrl + 'api/snaps/getmysnaps?UserID=' + userId;

    return this._http.post(url, {}).pipe(
      tap(
        () => { },
        () => {
          // error handling if needed
        }
      )
    );
  }

}
